module.exports = __webpack_public_path__ + "img/silver.ebddfc0a.png";